export default __webpack_public_path__ + "static/media/7.6095e4ca.png";